import { AlertBox, Button } from '@iwoca/orion-ui';
import { RootState } from '@iwProvider/configureStore';
import { ExclamationMarkOutlineSVG } from '@svgComponents/exclamationMarkOutlineSVG/ExclamationMarkOutlineSVG';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import messages from './RepayRequest.messages';
import { FormattedCurrency } from '../../../../../../iwIntlProvider/FormattedCurrency';
import { REQUEST_CHANGE_ROUTER } from '../../../../../../iwRouter/IwRouter.actions';
import { TAccount } from '../../../../iwocaPay.types';
import { getRepaymentSchedule } from '../../../../repaymentScheduleSelectors';

type TOwnProps = {
    account: TAccount;
};

const mapStateToProps = (state: RootState, { account }: TOwnProps) => {
    const repaymentSchedule: TAccount['scheduled_payments'] =
        getRepaymentSchedule(state, account);

    /**
    if the next repayment is same as "standard" equal repayment,
    we don't need to include "next repayment" section.

    api.lending.core.services.repayment_schedule:451

    First checking for the next_repayment, if it doesn't exist all repayments are equal
    So loading the equal repayment
    */
    const nextRepaymentAmount =
        repaymentSchedule?.summary?.simplified_schedule?.next_repayment
            ?.amount ||
        repaymentSchedule?.summary?.simplified_schedule?.equal_repayments
            ?.amount;

    return {
        accountId: account.account_id,
        nextRepaymentAmount
    };
};
const mapDispatchToProps = (dispatch: Dispatch) => ({
    goToEarlyRepayment: (accountId: NonNullable<TAccount['account_id']>) => {
        dispatch({
            type: REQUEST_CHANGE_ROUTER,
            location: {
                pathname: '/repayment/choose-amount/',
                search: `?accountId=${accountId}`
            }
        });
    }
});

// eslint-disable-next-line import/no-default-export
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(({ goToEarlyRepayment, account, nextRepaymentAmount }) => {
    return (
        <AlertBox
            variant="failure"
            className="mb-l flex flex-col items-start gap-m !bg-structure-100 p-l"
            data-testid="overdue-repay-request-section"
        >
            <div
                data-testid="overdue-repay-request-explanation"
                className="flex flex-col gap-m"
            >
                <div className="flex items-center gap-s">
                    <ExclamationMarkOutlineSVG className="min-h-l min-w-l" />
                    <p className="m-0 text-xl font-bold">
                        You have an overdue payment on this payment plan
                    </p>
                </div>
                {nextRepaymentAmount !== undefined ? (
                    <p className="m-0 text-m font-med">
                        <FormattedMessage
                            {...messages.explanation}
                            values={{
                                amount: (
                                    <span>
                                        <FormattedCurrency
                                            value={nextRepaymentAmount}
                                        />
                                    </span>
                                )
                            }}
                        />
                    </p>
                ) : (
                    <p className="m-0 text-m font-med">
                        Something went wrong. Please try again later.
                    </p>
                )}
            </div>

            <Button
                type="button"
                data-testid="overdue-repay-request-cta"
                onClick={() => goToEarlyRepayment(account.account_id!)}
            >
                <FormattedMessage {...messages.cta} />
            </Button>
        </AlertBox>
    );
});
